// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-checkbox-button-dict[data-v-25a50e7b]{min-height:300px}.el-checkbox-button-dict .el-checkbox-group[data-v-25a50e7b]{display:block}.el-checkbox-button-dict .el-checkbox-group+.el-checkbox-group[data-v-25a50e7b]{margin-top:20px}", ""]);
// Exports
module.exports = exports;
